import { createListenerMiddleware } from '@reduxjs/toolkit'

import AuthenticationStorage from '../../../shared/core/services/authentication-token'
import { authenticationLoginSuccess } from '../../actions/authentication-actions'

const authenticationLoginSuccessListener = createListenerMiddleware()

authenticationLoginSuccessListener.startListening({
  actionCreator: authenticationLoginSuccess,
  async effect({ payload: token }) {
    AuthenticationStorage.save(token)
    window.location.reload()
  }
})

export default authenticationLoginSuccessListener
